export default __webpack_public_path__ + "static/media/foot-right-side.1fd238be.png";